<template>
    <div class="maincontainer">
        <taskform ref="taskform" :ntask="ntask" :workersLoaded="workersLoaded"  :loaded="loaded" :workerItems="workerItems" :customers="customers" v-on:saveTask="saveTaskClicked" v-on:removeTask="removeTask" v-on:cloneTask="cloneTask"/>
        <div style="position: fixed;top: 100px; left: 0px;z-index: 101; background-color: white; padding-top: 30px; padding-left: 33px; padding-right: 33px; width: 100%">
            <div class="row">
                <div class="col m3 l4 xl6">
                    <template v-if="mode == 'days'">
                        <span style="font-size: larger;">{{currentDate.format('D MMMM YYYY')}}</span> <span style="text-transform: uppercase; font-weight: bold;">{{currentDate.format('dddd')}}</span>
                    </template>
                    <template v-if="mode == 'week'">
                        <span style="font-size: larger;" v-if="currentDate.clone().startOf('week').isSame(currentDate.clone().endOf('week'), 'month')">
                            {{currentDate.startOf('week').format('D')}} - {{currentDate.endOf('week').format('D MMMM YYYY')}}</span>
                        <span style="font-size: larger;" v-else-if="currentDate.clone().startOf('week').isSame(currentDate.clone().endOf('week'), 'year')">
                            {{currentDate.startOf('week').format('D MMMM')}} - {{currentDate.endOf('week').format('D MMMM YYYY')}}</span>
                        <span style="font-size: larger;" v-else>
                            {{currentDate.startOf('week').format('D MMMM YYYY')}} - {{currentDate.endOf('week').format('D MMMM YYYY')}}</span>
                    </template>
                    <br />
                    <button class="btn btn-add green" v-on:click="addTask()">{{$t('tasks.add_task')}}</button>
                    <div v-if="mode != 'list'" style="padding-top: 15px; width: 75%;"><selector v-model='typeofs' :items="taskstypes" identifier="typessel"></selector></div>
                </div>
                <div class="col m7 l6 xl4">
                    <button class="btn" v-on:click="setMode('list')" v-bind:class="{ red: mode == 'list', grey: mode != 'list'}">{{$t('tasks.modes.list')}}</button>
                    <button class="btn" v-on:click="setMode('days')" v-bind:class="{ red: mode == 'days', grey: mode != 'days'}">{{$t('tasks.modes.days')}}</button>
                    <button class="btn" v-on:click="setMode('week')" v-bind:class="{ red: mode == 'week', grey: mode != 'week' }">{{$t('tasks.modes.week')}}</button>
                    <button class="btn" v-on:click="setMode('month')" v-bind:class="{ red: mode == 'month', grey: mode != 'month' }">{{$t('tasks.modes.month')}}</button>
                    <br />
                    <br />
                    <button class="btn grey" v-on:click="weekAgo()" v-if="mode == 'week'"><i class="material-icons small cursor-pointer">navigate_before</i> </button>
                    <button class="btn white" v-on:click="thisWeek()" v-if="mode == 'week'">{{$t('tasks.this_week')}}</button>
                    <button class="btn grey" v-on:click="weekLater()" v-if="mode == 'week'"><i class="material-icons small cursor-pointer">navigate_next</i> </button>
                    <button class="btn grey" v-on:click="dayAgo()" v-if="mode == 'days'"><i class="material-icons small cursor-pointer">navigate_before</i> </button>
                    <button class="btn white" v-on:click="today()" v-if="mode == 'days'">{{$t('tasks.today')}}</button>
                    <button class="btn grey" v-on:click="dayLater()" v-if="mode == 'days'"><i class="material-icons small cursor-pointer" >navigate_next</i> </button>
                </div>
                <div class="col s2">
                    <table class="calendartable grey lighten-2">
                        <thead>
                            <tr>
                                <td><a v-on:click="monthAgo()"> <i class="material-icons small cursor-pointer">navigate_before</i> </a></td>
                                <td colspan="5">{{calDate.format('MMMM YYYY')}}</td>
                                <td><a v-on:click="monthLater()">
                                        <i class="material-icons small cursor-pointer">navigate_next</i>
                                    </a></td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="grey-text text-darken-1 daycolumn">{{$t('tasks.monday_short')}}</td>
                                <td class="grey-text text-darken-1 daycolumn">{{$t('tasks.tuesday_short')}}</td>
                                <td class="grey-text text-darken-1 daycolumn">{{$t('tasks.wednesday_short')}}</td>
                                <td class="grey-text text-darken-1 daycolumn">{{$t('tasks.thursday_short')}}</td>
                                <td class="grey-text text-darken-1 daycolumn">{{$t('tasks.friday_short')}}</td>
                                <td class="grey-text text-darken-1 daycolumn">{{$t('tasks.saturday_short')}}</td>
                                <td class="grey-text text-darken-1 daycolumn">{{$t('tasks.sunday_short')}}</td>
                            </tr>
                            <tr v-for="week in weeks">
                                <td v-for="day in week" v-on:click="selectDay(day)" class="cursor-pointer">
                                    <span v-bind:class="{ 'red':  currentDate.isSame(day, 'day'),'grey-text': calDate.isSame(day, 'month') == false }" style="padding: 3px;">{{day.format("D")}}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="row">
                    <div class="col s4">
                        
                    </div>
                    <div class="col s1"></div>
                </div>
            </div>
        </div>
        <table v-if="mode == 'month'" style="margin-top: 250px;">
            <thead v-if="loaded">
                <tr>
                    <td class="grey-text text-darken-1 daycolumn">{{$t('tasks.monday')}}</td>
                    <td class="grey-text text-darken-1 daycolumn">{{$t('tasks.tuesday')}}</td>
                    <td class="grey-text text-darken-1 daycolumn">{{$t('tasks.wednesday')}}</td>
                    <td class="grey-text text-darken-1 daycolumn">{{$t('tasks.thursday')}}</td>
                    <td class="grey-text text-darken-1 daycolumn">{{$t('tasks.friday')}}</td>
                    <td class="grey-text text-darken-1 daycolumn">{{$t('tasks.saturday')}}</td>
                    <td class="grey-text text-darken-1 daycolumn">{{$t('tasks.sunday')}}</td>
                </tr>
            </thead>
            <tbody v-if="loaded">
                <tr v-for="week in weeks">
                    <td v-for="day in week" v-on:click="selectDay(day)" class='cell' style="vertical-align: baseline;">
                        <div><span v-bind:class="{ 'grey-text': currentDate.isSame(day, 'month') == false }">{{day.format("D")}}</span></div>
                        <div class="tasklist">
                            <div style="width: 2.5em; border-radius: 50%; text-align: center; height: 2.5em;line-height: 2em;" v-bind:class="{ intervention: e.kind == 'intervention', inspection: e.kind == 'inspection', installation: e.kind == 'installation', other: e.kind == 'other' }" v-for="e in listMonthsItems[day.format('DD-MM-YYYY')]"  :key="e.id" v-on:click="showTask(e)">
                                {{initialsById(e.worker_ids)}}
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
            <preloader v-if="loaded == false" n="6" />
        </table>
        <table v-if="mode == 'list'" style="margin-top: 250px;">
            <thead style="background-color: #DADADA; padding: 15px; position: sticky; top: 290px;">
                <tr>
                    <th v-on:click="set_order('startsAt')" style="width: 12%;">
                        <span>{{$t('tasks.list_headers.date')}} </span>
                        <i class="material-icons dp6" v-if="orderby == 'startsAt' && order == 'desc'">arrow_drop_down</i>
                        <i class="material-icons dp6" v-if="orderby == 'startsAt' && order == 'asc'">arrow_drop_up</i>
                        <div class="input-field">
                            <select v-model="rangeSelected">
                              <option value="currentMonth">{{$t('calendar.current_month')}}</option>
                              <option value="prevMonth">{{$t('calendar.prev_month')}}</option>
                              <option value="lastThreeMonths">{{$t('calendar.last_three_months')}}</option>
                              <option value="currentYear">{{$t('calendar.current_year')}}</option>
                              <option value="prevYear">{{$t('calendar.previous_year')}}</option>
                              <option value="other">{{$t('calendar.other_range')}}</option>
                            </select>
                        </div>
                        <div class="row" v-if="rangeSelected == 'other'">
                          <div class="col s6 input-field" style="padding-left: 0px;padding-right: 5px;">
                            <input type="date" v-model="tasksTimeRange.startDate" style="font-size: 12px;" />
                            <button class="waves-effect waves-light btn-large red" style="border-radius: 8px; line-height: 2.5; height: 35px; padding-left: 0px;padding-right: 0px; width: 100%; font-size: 12px;" v-on:click="cancelChanges()">{{$t('calendar.cancel')}}</button>
                          </div>
                          <div class="col s6 input-field" style="padding-right: 5px;padding-left: 5px;">
                            <input type="date" v-model="tasksTimeRange.endDate" style="font-size: 12px;" />
                            <button class="waves-effect waves-light btn-large green" style="border-radius: 8px; line-height: 2.5; height: 35px; padding-left: 0px;padding-right: 0px; width: 100%; font-size: 12px;" v-on:click="applyChanges()">{{$t('calendar.apply')}}</button>
                          </div>
                        </div>
                    </th>
                    <th v-on:click="set_order('types')" style="width: 20%;">
                        <span>{{$t('tasks.list_headers.types')}}</span>
                        <i class="material-icons dp6" v-if="orderby == 'types' && order == 'desc'">arrow_drop_down</i>
                        <i class="material-icons dp6" v-if="orderby == 'types' && order == 'asc'">arrow_drop_up</i>
                        <selector v-model="selections" :items="items"></selector>
                    </th>
                    <th v-on:click="set_order('place_name')" style="width: 20%; padding-top: 15px;" class="input-field">
                        <span>{{$t('tasks.list_headers.where')}}</span>
                        <i class="material-icons dp6" v-if="orderby == 'place_name' && order == 'desc'">arrow_drop_down</i>
                        <i class="material-icons dp6" v-if="orderby == 'place_name' && order == 'asc'">arrow_drop_up</i>
                        <input v-model="place_name" name="" style="width: 100%; margin-top: 4px;" />
                    </th>
                    <th v-on:click="set_order('worker')" style="width: 20%;">
                        <span>{{$t('tasks.list_headers.worker')}}</span>
                        <i class="material-icons dp6" v-if="orderby == 'worker' && order == 'desc'">arrow_drop_down</i>
                        <i class="material-icons dp6" v-if="orderby == 'worker' && order == 'asc'">arrow_drop_up</i>
                        <selector v-model="selectedWorkers" :items="workerItems" identifier="workers"></selector>
                    </th>
                    <th v-on:click="set_order('status')" style="width: 10%;">
                        <span>{{$t('tasks.list_headers.status')}}</span>
                        <i class="material-icons dp6" v-if="orderby == 'status' && order == 'desc'">arrow_drop_down</i>
                        <i class="material-icons dp6" v-if="orderby == 'status' && order == 'asc'">arrow_drop_up</i>
                        <selector v-model="statuses" :items="statuslist"></selector>
                    </th>
                </tr>
            </thead>
            <tbody v-if="loaded">
                <template v-for="(task, index) in listItems">
                    <tr v-on:click="showTask(task)">
                        <td>{{task.startsAt | formatDateWithHour}} - {{task.endsAt | formatDateWithHour}}</td>
                        <td>
                            {{task.typeof | nameTaskType}}
                            <template v-if="task.typeof == 'other'">
                            {{task.typeof_other}}
                            </template>
                            <template v-if="task.typeof == 'intervention'">
                                <template v-if="task.intervention_type == 'other'">
                                    {{task.intervention_type_other}}
                                </template>
                                <template v-else>
                                    {{intervention_types[task.intervention_type]}}
                                </template>
                            </template>
                        </td>
                        <td v-if="task.place != null">{{task.place.name}}</td>
                        <td v-else><span v-if="task.address != undefined">{{task.address.street}}, {{task.address.city}}</span></td>
                        <td>{{task.worker_ids | nameByIds(workers)}}</td>
                        <td>{{statuseslabels[task.status]}}</td>
                    </tr>
                </template>
            </tbody>
            <preloader v-if="loaded == false" n="6" />
        </table>
        <template v-if="listItems.length == 0 && loaded == true"><p style="font-size: 12px;">{{$t('tasks.not_found')}}</p></template>
        <day v-if="mode == 'days'" :workerItems="workerItems" :loaded="loaded" :workersLoaded="workersLoaded" :days="listWeeksItems" :selectedWorkers="selectedWorkers" :listWorkersItems="listWorkersItems" v-on:taskmoved="saveTask" :placesdict="placesdict" v-on:taskClicked="showTask" v-on:reorder="reordered" :date="currentDate" @addtask="addTask" />
        <week v-if="mode == 'week'" :days="listWeeksItems" :loaded="loaded" :workerItems="workerItems" v-on:click="showTask" :placesdict="placesdict" v-on:taskmoved="saveTask" />
    </div>
</template>
<script>
import Vue2Filters from 'vue2-filters'
import axios from 'axios';
import _ from 'lodash';
import Moment from 'moment';
import 'moment/locale/pl'
import { extendMoment } from 'moment-range';
import VueCookies from 'vue-cookies'

const moment = extendMoment(Moment);
moment.locale('pl')
export default {
    data: function() {
        return {
            order: 'desc',
            orderby: 'number',
            from: moment().startOf("month").format("YYYY-MM-DD"),
            to: moment().endOf("month").format("YYYY-MM-DD"),
            tasks: [],
            edit: false,
            loaded_task: false,
            selectedWorkers: [],
            typeofs: ["inspection", "installation", "intervention", "other"],
            workerslist: [],
            workerItems: [],
            workers: [],
            rangeSelected: "currentMonth",
            place_name: "",
            customers: [],
            selections: [],
            weeks: [],
            now: moment(),
            lineoffset: 0,
            hover: false,
            statuses: [],
            items: [
                {"name": this.$t('tasks.intervention'), "value": 'intervention:null'},
                {"name": this.$t('tasks.disinsection'), "value": 'intervention:disinsection'},
                {"name": this.$t('tasks.disinfection'), "value": 'intervention:disinfection'},
                {"name": this.$t('tasks.deratization'), "value": 'intervention:deratization'},
                {"name": this.$t('tasks.other'), "value": 'intervention:other'},
                {"name": this.$t('tasks.inspection'), "value": 'inspection:null'},
                {"name": this.$t('tasks.installation'), "value": 'installation:null'},
                {"name": this.$t('tasks.other_task'), "value": 'other:null'},
            ],
            statuslist: [
                {"name":  this.$t('tasks.statuses.dateset'), "value": "dateset"},
                {"name":  this.$t('tasks.statuses.no_date'), "value": "no_date"},
                {"name":  this.$t('tasks.statuses.pending'), "value": "pending"},
                {"name":  this.$t('tasks.statuses.finished_worker'), "value": "finished_worker"},
                {"name":  this.$t('tasks.statuses.cleared'), "value": "cleared"},
                {"name":  this.$t('tasks.statuses.refused'), "value": "refused"}
            ],
            statuseslabels: {
                "dateset":  this.$t('tasks.statuses.dateset'),
                "no_date":  this.$t('tasks.statuses.no_date'),
                "pending":  this.$t('tasks.statuses.pending'),
                "finished_worker":  this.$t('tasks.statuses.finished_worker'),
                "cleared":  this.$t('tasks.statuses.cleared'),
                "refused":  this.$t('tasks.statuses.refused')
            },
            loadedFragments: [],
            placesdict: {},

            ntask: {
                typeof: 'intervention',
                status: 'dateset',
                routine: false,
                worker_ids: [],
                place_id: null,
                startsAt: moment().format('YYYY-MM-DDTHH:mm'),
                endsAt: moment().add(1, 'hour').format('YYYY-MM-DDTHH:mm'),
                address: {
                    name: "",
                    street: "",
                    city: "",
                    postal_code: ""
                },
                phone_number: "",
                photos: [],
                versions: [],
                comments: []
            },
            mode: 'days',
            taskstypes: [
                { name: this.$t('tasks.kindnames.inspection'), value: "inspection" },
                { name: this.$t('tasks.kindnames.installation'), value: "installation" },
                { name: this.$t('tasks.kindnames.intervention'), value: "intervention" },
                { name: this.$t('tasks.kindnames.other'), value: "other" }
            ],
            tasksnames: { 'intervention': this.$t('tasks.kindnames.intervention'), 'inspection': this.$t('tasks.kindnames.inspection'), "installation": this.$t('tasks.kindnames.installation'), 'other': this.$t('tasks.kindnames.other') },
            intervention_types: { 'deratization': this.$t('tasks.intervention_names.deratization'), 'disinfection': this.$t('tasks.intervention_names.disinfection'), 'disinsection': this.$t('tasks.intervention_names.disinsection'), 'other': this.$t('tasks.intervention_names.other') },
            loaded: false,
            workersLoaded: false,
            hours: _.range(0, 24),
            currentDate: moment(),
            calDate: moment(),
            tasksTimeRange: { startDate: moment().startOf('day').format("YYYY-MM-DD"), endDate: moment().endOf('day').format("YYYY-MM-DD") },
            instances: undefined,
            editdate: false,
            lastLoad: 0
        }
    },
    meta: {
        title: "Zadania"
    },
    created() {
        this.fetch_places();
        this.generateWeeks();
        var fromCookies = this.$cookies.get('collapsedworkers') || "[]";
        if (fromCookies != null) {
            var mem = JSON.parse(fromCookies);
            this.selectedWorkers.push(...mem);
        }
    },
    mounted() {
        window.scrollTo(0, 6 * 52);
        var that = this;
        var starts = document.querySelectorAll('.timestartpicker');
        var ends = document.querySelectorAll('.timeendpicker');
        var translates = {
            cancel: this.$t('menu.buttons.cancel'),
            clear: this.$t('menu.buttons.clear'),
            done: this.$t('menu.ok'),

        }
        var startsTime = [];
        var endsTime = [];
        var instances = M.Timepicker.init(starts, {
            twelveHour: false,
            i18n: translates,
            onSelect: function(hh, mm) {
                startsTime = [hh, mm];
            },
            onCloseStart: function(a) {},
            onCloseEnd: function(a) {
                if (startsTime.length == 2) {
                    that.taskStartAtTime = moment({ hour: startsTime[0], minutes: startsTime[1] }).format("HH:mm");
                }
            },
            onOpenStart: function(a) {
                var that = this;
                that.hasEvent = false;
                var cancelbtn = a.querySelectorAll('.timepicker-close:nth-child(1)')[0];
                var okbtn = a.querySelectorAll('.timepicker-close:nth-child(2)')[0];
                var cancelfn = function(that) {
                    cancelbtn.removeEventListener('click', cancelfn)
                };
                var okfn = function(that) {
                    okbtn.removeEventListener('click', okfn)
                };
                cancelbtn.addEventListener('click', cancelfn);
                okbtn.addEventListener('click', okfn);
            }
        });
        var instances = M.Timepicker.init(ends, {
            twelveHour: false,
            i18n: translates,
            onSelect: function(hh, mm) {
                endsTime = [hh, mm];
            },
            onCloseStart: function(a) {},
            onCloseEnd: function(a) {
                if (endsTime.length == 2) {
                    that.taskEndsAtTime = moment({ hour: endsTime[0], minutes: endsTime[1] }).format("HH:mm");
                }
            },
            onOpenStart: function(a) {
                var cancelbtn = a.querySelectorAll('.timepicker-close:nth-child(1)')[0];
                var okbtn = a.querySelectorAll('.timepicker-close:nth-child(2)')[0];
                var that = this;
                that.hasEvent = false;
                var cancelfn = function(that) {
                    cancelbtn.removeEventListener('click', cancelfn)
                };
                var okfn = function(that) {
                    okbtn.removeEventListener('click', okfn)
                };
                cancelbtn.addEventListener('click', cancelfn)
                okbtn.addEventListener('click', okfn)
            }
        });
    },
    methods: {
        fetch_places: async function() {
            window.scrollTo(0, 800);
            this.fromload = moment().subtract(1, 'months').startOf('month').unix();
            this.toload = moment().add(1, 'months').endOf('month').unix();
            var response = await axios.get('/customers.json')
            this.customers = response.data;
            for (var i in this.customers) {
                var customer = this.customers[i];
                for (var j in customer.places) {
                    var place = customer.places[j];
                    this.placesdict[place.id] = place.name;
                }
            }
            var response = await axios.get('/tasks/' + this.fromload + '/' + this.toload + '.json')
            this.tasks = response.data;
            for (var i in this.tasks) {
                var task = this.tasks[i];
                task.startsAt = moment(task.startsAt).format('YYYY-MM-DDTHH:mm');
                task.endsAt = moment(task.endsAt).format('YYYY-MM-DDTHH:mm');
                task.place_name = ""
                if(task.place != null){
                    task.place_name = "" + task.place.name
                } 
                if(task.address != null){
                    task.place_name = "" + task.address.street + task.address.city
                }
            }
            this.lastLoad = _.now()
            this.loaded = true;
            response = await axios.get('/workers.json')
            this.workers = response.data;
            this.workersdict = {};
            var fromCookies2 = this.$cookies.get('orderedworkers') || "[]";
            var mem = JSON.parse(fromCookies2);
            if (mem.length > 0) {
                this.workers = this.workers.filter(function(worker) { return worker.active }).sort(function(a, b) {
                    return mem.indexOf(a.id) - mem.indexOf(b.id);
                })
            }
            var emptyworkers = this.selectedWorkers.length == 0;
            for (var i in this.workers) {
                var item = this.workers[i];
                if (item.active == true) {
                    this.workerItems.push({ value: item.id, name: item.name + " " + item.surname, symbol: item.symbol });
                    this.workersdict[item.id] = { value: item.id, name: item.name + " " + item.surname, symbol: item.symbol };
                    if (emptyworkers) {
                        this.selectedWorkers.push(item.id)
                    }
                }
            }
            this.workerItems.push({ value: -1, name: this.$t('tasks.unassigned'), symbol: "." });
            this.workersLoaded = true;
            window.scrollTo(0, 900);
        },
        reordered(value) {
            this.workerItems = value;
            this.$cookies.set('orderedworkers', JSON.stringify(value.map(worker => worker.value)));
        },
        collapse: function(customer) {
            customer.collapsed = !(customer.collapsed);
            this.$forceUpdate();
        },
         applyChanges: function(){
          this.from = this.fromSelected;
          this.to = this.toSelected;
          this.loadFragmentIfNeeded(moment(this.from), moment(this.to))
        },
        set_order: function(order) {
            if (this.orderby == order) {
                if (this.order == 'desc') {
                    this.order = 'asc'
                } else if (this.order == 'asc') {
                    this.order = 'desc'
                }

            } else {
                this.orderby = order;
            }
        },
        async loadFragmentIfNeeded(f, t) {
            var diffInSeconds = ((_.now() - this.lastLoad) / (1000));
            if ((this.fromload <= f.unix() && this.toload >= t.unix()) && diffInSeconds < 300) {
                console.log("Loading of fragment not neeeded");
            } else {
                this.loaded = false;
                var response = await axios.get('/tasks/' + f.unix() + '/' + t.unix() + '.json');
                this.fromload = f.unix();
                this.toload = t.unix();
                this.tasks = response.data;
                for (var i = 0; i < this.tasks.length; i++) {
                    var task = this.tasks[i];
                    task.place_name = ""
                    if(task.place != null){
                        task.place_name = "" + task.place.name
                    } 
                    if(task.address != null){
                        task.place_name = "" + task.address.street + task.address.city
                    }
                }
                this.loaded = true;
                this.lastLoad = _.now()
            }

        },
        moveline: function(event) {
            if (this.hover && event.target.tagName == "TH") {
                var rect = event.target.parentElement.parentElement.getBoundingClientRect();
                var x = event.clientX - rect.left; //x position within the element.
                var y = event.clientY - rect.top; //y position within the element.
                this.lineoffset = y;
            }
        },
        monthAgo: function() {
            this.calDate.add(-1, 'months');
            this.generateWeeks();
            this.$forceUpdate();
            this.loadFragmentIfNeeded(this.calDate.clone().startOf('month'), this.calDate.clone().endOf('month'));
        },
        monthLater: function() {
            this.calDate.add(1, 'months');
            this.generateWeeks();
            this.$forceUpdate();
            this.loadFragmentIfNeeded(this.calDate.clone().startOf('month'), this.calDate.clone().endOf('month'));
        },
        selectDay(day) {
            this.currentDate = day;
            this.tasksTimeRange.startDate = this.currentDate.clone().startOf(this.mode).format("YYYY-MM-DD")
            this.tasksTimeRange.endDate = this.currentDate.clone().endOf(this.mode).format("YYYY-MM-DD")
            this.generateWeeks();
            this.$forceUpdate();
            this.loadFragmentIfNeeded(this.currentDate.clone().startOf('month'), this.currentDate.clone().endOf('month'));
        },
        generateWeeks() {
            var start = this.calDate.clone().startOf('month').startOf('week')
            var end = this.calDate.clone().endOf('month').endOf('week')
            var out = []
            var startWeek = start.week();
            var endWeek = end.week();
            start.add(-1, 'days')
            if (startWeek > endWeek) {
                endWeek = endWeek + moment().weeksInYear()
            }
            for (var week in _.range(0, 6)) {
                out.push([start.add(1, 'days').clone(), start.add(1, 'days').clone(), start.add(1, 'days').clone(), start.add(1, 'days').clone(), start.add(1, 'days').clone(), start.add(1, 'days').clone(), start.add(1, 'days').clone()])
            }
            this.weeks = out
        },
        setMode(mode) {
            this.tasksTimeRange.startDate = this.currentDate.clone().startOf(mode != 'list' ? mode : 'month').format("YYYY-MM-DD")
            this.tasksTimeRange.endDate = this.currentDate.clone().endOf(mode != 'list' ? mode : 'month').format("YYYY-MM-DD")
            this.mode = mode
        },
        cloneTask(task){
            this.instances[0].close()
            var tsk = _.clone(task)
            delete tsk.id
            tsk.status = "dateset"
            tsk.photos = []
            this.addTask(undefined, tsk)
        },
        addTask(hour, task) {
            var start = moment();
            var startreminder = 15 - (start.minute() % 15);
            var end = moment().add(1, 'hour');
            if(this.mode == "days"){
                start = moment().set({date: this.currentDate.date(), month: this.currentDate.month(), year: this.currentDate.year()});
                startreminder = 15 - (start.minute() % 15);
                end = moment().set({date: this.currentDate.date(), month: this.currentDate.month(), year: this.currentDate.year()}).add(1, 'hour');
            }
            
            if(hour != undefined){
                if(_.isArray(hour)){
                    start.set('hour',hour[0].hour())
                    start.set('minutes', hour[0].minutes());
                    start.set('seconds', 0);
                    end.set('hour',hour[1].hour())
                    end.set('minutes', hour[1].minutes());
                    end.set('seconds', 0);
                    startreminder = 0;
                    console.log(start, end)
                }else{
                    var tmpHour = moment(hour, 'HH:mm')
                    start.set('hour', tmpHour.hour());
                    start.set('minutes', 0);
                    startreminder = 0;
                    end = start.clone().add(1, 'hour');
                }
            }
            var elems = document.querySelectorAll('.modal');
            if(task == undefined){
                this.ntask = {
                    name: "",
                    status: 'dateset',
                    routine: false,
                    worker_ids: [],
                    place_id: null,
                    startsAt: start.clone().add(startreminder, 'minutes').format('YYYY-MM-DDTHH:mm'),
                    endsAt: end.clone().add(startreminder, 'minutes').format('YYYY-MM-DDTHH:mm'),
                    phone_number: "",
                    address: {
                        name: "",
                        street: "",
                        city: "",
                        postal_code: ""
                    },
                    payment_method: "cash",
                    net_price: 0,
                    pricing: 0,
                    versions: [],
                    comments: [],
                    typeof: 'intervention',
                    intervention_type_other: "",
                    typeof_other: '',
                    reconescance: "",
                    physical_mount: false,
                    name: "",
                    photos: [],
                    edit: true
                }
            }else{
                this.ntask = task;
                var startOf = moment(this.ntask.startsAt);
                var endOf = moment(this.ntask.endsAt);
                this.ntask.startsAt = moment().set('hour', startOf.hour()).set('minute', startOf.minute()).add(1, 'day').format('YYYY-MM-DDTHH:mm')
                this.ntask.endsAt = moment().set('hour', endOf.hour()).set('minute', endOf.minute()).add(1, 'day').format('YYYY-MM-DDTHH:mm')
                this.ntask.edit = true
                console.log("Copied task", this.ntask)
            }
          
            this.instances = M.Modal.init(elems, { startingTop: '0%', preventScrolling: true, dismissible: false});
            if(!_.isUndefined(this.instances[0])) this.instances[0].open()
        },
        showTask: async function(task) {
            task.edit = false;
            this.ntask = task;
            this.ntask.startsAt = moment(this.ntask.startsAt).utcOffset(1, true).format('YYYY-MM-DDTHH:mm');
            this.ntask.endsAt = moment(this.ntask.endsAt).utcOffset(1, true).format('YYYY-MM-DDTHH:mm');
            this.ntask.phone_number ||= "";
            var elems = document.querySelectorAll('.modal');
            this.instances = M.Modal.init(elems, { startingTop: '0%', preventScrolling: true, dismissible: false});
            if(!_.isUndefined(this.instances[0])) this.instances[0].open()
            var resp = await axios.get('/tasks/' + task.id + ".json");
            task.comments = resp.data.comments
            task.versions = resp.data.versions
            task.photos = resp.data.photos
            task.status = resp.data.status
            this.ntask = _.clone(task);
            this.ntask.address ||= {
                street: "",
                city: "",
                postal_code: ""
            };
            
        },
        saveTaskClicked: async function(task) {
            try{
                await this.saveTask(task)
            }catch(error){

            }
            this.$refs.taskform.saving = false;
            if (this.instances != undefined) {
                if(!_.isUndefined(this.instances[0])) this.instances[0].close()
            }
        },
        saveTask: async function(task) {
            if (task != null) {
                this.ntask = task;
            }
            if(moment(this.ntask.startsAt).isAfter(this.ntask.endsAt)){
                return false;
            } 
            const formData = new FormData();
            formData.append('task[startsAt]', moment(this.ntask.startsAt).utcOffset(1, false).format('YYYY-MM-DDTHH:mmZZ'));
            formData.append('task[endsAt]', moment(this.ntask.endsAt).utcOffset(1, false).format('YYYY-MM-DDTHH:mmZZ'));
            formData.append('task[typeof]', this.ntask.typeof);
            formData.append('task[payment_method]', this.ntask.payment_method || "cash");
            formData.append('task[net_price]', this.ntask.net_price);
            formData.append('task[pricing]', this.ntask.pricing);
            if (this.ntask.routine) formData.append('task[routine]', true);
            formData.append('task[name]', this.ntask.name);
            formData.append('task[status]', this.ntask.status);
            formData.append('task[reconescance]', this.ntask.reconescance);
            formData.append('task[physical_mount]', this.ntask.physical_mount);
            formData.append('task[intervention_type_other]', this.ntask.intervention_type_other || "");
            formData.append('task[typeof_other]', this.ntask.typeof_other);
            if (_.isUndefined(this.ntask.worker_ids) == false) {
                for (var index in _.range(0, this.ntask.worker_ids.length)) {
                    var worker_id = this.ntask.worker_ids[index];
                    if(worker_id != -1){
                        formData.append('task[worker_ids][]', worker_id);
                    }
                }
            }
            if (_.isUndefined(this.ntask.photos) == false) {
                for (var index in _.range(0, this.ntask.photos.length)) {
                    if(this.ntask.photos[index].attachment instanceof File) formData.append('task[media_attributes][' + index + '][image]', this.ntask.photos[index].attachment);
                    if (this.ntask.photos[index].id) {
                        formData.append('task[media_attributes][' + index + '][id]', this.ntask.photos[index].id);
                    }
                    if (this.ntask.photos[index].destroy) {
                        formData.append('task[media_attributes][' + index + '][_destroy]', true);
                    }
                }
            }
            if (this.ntask.typeof == 'intervention') formData.append('task[intervention_type]', this.ntask.intervention_type);
            if(_.isUndefined(this.ntask.phone_number) == false){
                formData.append('task[phone_number]', this.ntask.phone_number);
            }
            if (this.ntask.routine == false && (this.ntask.typeof == 'other' || this.ntask.typeof == 'intervention')) {
                formData.append('task[address_attributes][name]', this.ntask.address.name || "");
                formData.append('task[address_attributes][street]', this.ntask.address.street);
                formData.append('task[address_attributes][city]', this.ntask.address.city);
                formData.append('task[address_attributes][postal_code]', this.ntask.address.postal_code);
                formData.append('task[place_id]', null);
            } else {
                formData.append('task[place_id]', this.ntask.place_id);
            }
            var task_id = this.ntask.id;
            if (task_id) {
                var response = await axios.put('/tasks/' + task_id + '.json', formData)
                var task = _.cloneDeep(response.data)
                var task_index = this.tasks.indexOf(_.find(this.tasks, { id: task_id }));
                if(task_index > -1) this.tasks.splice(task_index, 1);
            } else {
                var response = await axios.post('/tasks.json', formData)
                var task = _.cloneDeep(response.data)
            }
            task.startsAt = moment(task.startsAt).format('YYYY-MM-DDTHH:mm')
            task.endsAt = moment(task.endsAt).format('YYYY-MM-DDTHH:mm')
            if(this.tasks.indexOf() == -1) this.tasks.push(task)
            this.ntask = null
        },
        removeTask: async function() {
            var response = await axios.delete('/tasks/' + this.ntask.id + '.json')
            this.tasks.splice(this.tasks.indexOf(_.find(this.tasks, { id: this.ntask.id })), 1)
            if(!_.isUndefined(this.instances[0])) this.instances[0].close()
        },
        weekAgo() {
            this.selectDay(this.currentDate.clone().add(-1, 'week'));
        },
        weekLater() {
            this.selectDay(this.currentDate.clone().add(1, 'week'));
        },
        dayAgo() {
            this.selectDay(this.currentDate.clone().add(-1, 'day'));
        },
        dayLater() {
            this.selectDay(this.currentDate.clone().add(1, 'day'));
        },
        thisWeek() {
            this.currentDate = moment()
            this.generateWeeks()
        },
        today() {
            this.currentDate = moment()
            this.selectDay(this.currentDate);
            this.generateWeeks()
            this.$forceUpdate();
        },
        getTimeFraction(date) {
            var hh = moment(date).hours();
            var mm = moment(date).minutes();
            return 30 + (((hh * 60.0 + mm) / 60) * (100));
        },
        initialsById(workers) {
            if (_.keyBy(this.workerItems, 'value')[workers[0]] == undefined) return "."
            return _.keyBy(this.workerItems, 'value')[workers[0]].symbol
        }
    },
    computed: {
        listItems() {
            var that = this;
            return _.filter(
                _.orderBy(this.tasks, this.orderby, this.order),
                function(item) {
                    const range = moment.range(moment(that.tasksTimeRange.startDate).startOf('day'), moment(that.tasksTimeRange.endDate).endOf('day'));
                    const outerRange = moment.range(moment(item.startsAt).startOf('day'), moment(item.endsAt).endOf('day'));
                    var [types, intervention_types]  = _.zip(...that.selections.map(str => str.split(':')))
                    types = _.uniq(types)
                    intervention_types = _.reject(intervention_types, function(element){return element == 'null'})
                    var within_time_range = range.overlaps(outerRange);
                    var in_workers_selected = ( _.intersection( that.selectedWorkers, item.worker_ids).length > 0 || that.selectedWorkers.length == 0) || (item.worker_ids.length == 0 && that.selectedWorkers.indexOf(-1) > -1) || that.mode != 'list';
                    var in_statuses = ( _.intersection( that.statuses, [item.status]).length > 0 || that.statuses.length == 0);
                    var in_names = ((item.place_name || "").toLowerCase().indexOf((that.place_name || "").toLowerCase()) > -1 || (that.place_name || "").length == 0)
                    var in_kinds = _.includes(types, item.kind) || types.length == 0 
                    var in_task_types = item.kind != 'intervention' || intervention_types.length == 0 || _.includes(intervention_types, item.intervention_type)
                    return within_time_range && in_workers_selected && in_statuses && in_kinds && in_task_types &&
                        in_names
                }
            );
        },
        listAllItems() {
            var that = this;
            return _.filter(
                _.orderBy(this.tasks, this.orderby, this.order),
                function(item) {
                    const range = moment.range(moment(that.tasksTimeRange.startDate).startOf('day'), moment(that.tasksTimeRange.endDate).endOf('day'));
                    const outerRange = moment.range(moment(item.startsAt).startOf('day'), moment(item.endsAt).endOf('day'));
                    var within_time_range = range.overlaps(outerRange);
                    var in_kinds = _.includes(that.typeofs, item.kind) || that.typeofs.length == 0 
                    return within_time_range  && in_kinds
                }
            );
        },
        customers_options() {
            return _.map(this.customers, (customer) => {
                return {
                    name: customer.name,
                    items: _.map(customer.places, (place) => {
                        return { name: place.name, value: place.id };
                    })
                };
            })
        },

        listWeeksItems() {
            var out = [];
            var that = this;
            var sow = this.currentDate.clone().startOf('week');
            var eow = this.currentDate.clone().endOf('week');
            var itms = _.orderBy(this.tasks, 'startsAt', 'asc');
            for (var m = moment(sow); m.isBefore(eow); m.add(1, 'days')) {
                out.push([m.format('dddd, D'),
                    _.filter(
                        itms,
                        function(item) {
                            return moment(item.startsAt).isSame(m, 'day') &&
                                (
                                    _.intersection(that.selectedWorkers, item.worker_ids).length > 0 || that.selectedWorkers.length == 0
                                ) && (
                                    _.intersection(that.typeofs, [item.kind]).length > 0 || that.typeofs.length == 0
                                )
                        })
                ]);
            }
            return out
        },
        listMonthsItems() {
            var out = {};
            var that = this;
            var sow = this.currentDate.clone().startOf('month').startOf('week');
            var eow = this.currentDate.clone().endOf('month').endOf('week');
            var itms = _.filter(_.orderBy(this.tasks, 'startsAt', 'asc'), function(item) {
                return (_.intersection(that.selectedWorkers, item.worker_ids).length > 0 || that.selectedWorkers.length == 0) &&
                    (
                        _.intersection(that.typeofs, [item.kind]).length > 0 || that.typeofs.length == 0
                    )
            })
            for (var m = moment(sow); m.isBefore(eow); m.add(1, 'days')) {
                out[m.format('DD-MM-YYYY')] = _.filter(
                    itms,
                    function(item) {
                        return moment(item.startsAt).isSame(m, 'day')
                    });
            }
            return out
        },
        listWorkersItems() {
            var out = {};
            for (var task in this.listAllItems) {
                for (var worker in this.listAllItems[task].worker_ids) {
                    if (_.isUndefined(out[this.listAllItems[task].worker_ids[worker]])) {
                        out[this.listAllItems[task].worker_ids[worker]] = [];
                    }
                    out[this.listAllItems[task].worker_ids[worker]].push(this.listAllItems[task])
                }
                if (this.listAllItems[task].worker_ids.length == 0) {

                    if (_.isUndefined(out[this.listAllItems[task].worker_ids['undefined']])) {
                        out[this.listAllItems[task].worker_ids['undefined']] = [];
                    }
                    out[this.listAllItems[task].worker_ids['undefined']].push(this.listAllItems[task])
                }
            }
            for (var i = _.keys(out).length - 1; i >= 0; i--) {
                out[_.keys(out)[i]] = _.sortBy(out[_.keys(out)[i]], [function(o) { return moment(o.startsAt).unix(); }])
            }
            return out;
        }
    },
    watch: {
        rangeSelected: function (val) {
          if(val == "currentMonth"){
            this.lastRange = val;
            this.from = moment().startOf("month").format("YYYY-MM-DD")
            this.tasksTimeRange.startDate = moment().startOf("month").format("YYYY-MM-DD")
            this.to = moment().endOf("month").format("YYYY-MM-DD")
            this.tasksTimeRange.endDate = moment().endOf("month").format("YYYY-MM-DD")
          }else if(val == "prevMonth"){
            this.lastRange = val;
            this.from = moment().subtract(1,'months').startOf("month").format("YYYY-MM-DD")
            this.tasksTimeRange.startDate = moment().subtract(1,'months').startOf("month").format("YYYY-MM-DD")
            this.to = moment().subtract(1,'months').endOf("month").format("YYYY-MM-DD")
            this.tasksTimeRange.endDate = moment().subtract(1,'months').endOf("month").format("YYYY-MM-DD")
          }else if(val == "lastThreeMonths"){
            this.lastRange = val;
            this.from = moment().subtract(3,'months').startOf("month").format("YYYY-MM-DD")
            this.tasksTimeRange.startDate = moment().subtract(3,'months').startOf("month").format("YYYY-MM-DD")
            this.to = moment().endOf("month").format("YYYY-MM-DD")
            this.tasksTimeRange.endDate = moment().endOf("month").format("YYYY-MM-DD")
          }else if(val == "currentYear"){
            this.lastRange = val;
            this.from = moment().startOf("year").format("YYYY-MM-DD")
            this.tasksTimeRange.startDate = moment().startOf("year").format("YYYY-MM-DD")
            this.to = moment().endOf("year").format("YYYY-MM-DD")
            this.tasksTimeRange.endDate = moment().endOf("year").format("YYYY-MM-DD")
          }else if(val == "prevYear"){
            this.lastRange = val;
            this.from = moment().subtract(1,'years').startOf("year").format("YYYY-MM-DD")
            this.tasksTimeRange.startDate = moment().subtract(1,'years').startOf("year").format("YYYY-MM-DD")
            this.to = moment().subtract(1,'years').endOf("year").format("YYYY-MM-DD")
            this.tasksTimeRange.endDate = moment().subtract(1,'years').endOf("year").format("YYYY-MM-DD")
          }
          this.loadFragmentIfNeeded(moment(this.tasksTimeRange.startDate).startOf('month'), moment(this.tasksTimeRange.endDate).endOf('month'));
        }
    },
    mixins: [Vue2Filters.mixin],
}
</script>
<style scoped>
.login_button {
    color: red;
}

/*p {
  font-size: 2em;
  text-align: center;
}*/
thead {
    font-size: 15px;
}

thead th {
    font-weight: 300;

}

table thead th:first-child {
    position: sticky;
    z-index: 2;
}

table>tr>td {

    padding-bottom: 5px;
}

thead>tr>td {
    padding-top: 5px;
}

.btn {
    color: black;
}

.btn.grey {
    background-color: #DADADA !important;
}

thead .input-field {
    margin-top: unset;
    padding-top: 5px;
    margin-bottom: unset;
}

.maincontainer {
    margin: 0px;
}

.calendartable td {
    padding: 0px 3px;
    font-size: 12px;
    text-align: center;
}

.calendartable tr {
    border-bottom: 0px;
}

.calendartable .red {
    background-color: #bbb;
    border-radius: 50%;
    text-align: center;
}

.calendartable .small {
    font-size: 2em;
}


.btn-add {
    border-radius: 8px;
    margin-top: 16px;
}

.task {
    position: absolute;
    max-width: 200px;
    width: 200px;
}

.intervention {
    background-color: rgba(244, 60, 250, 0.25);
}

.inspection {
    background-color: rgba(250, 244, 60, 0.25);
}

.installation {
    background-color: rgba(66, 250, 60, 0.25);
}

.other {
    background-color: rgba(60, 117, 250, 0.25);
}

.intervention,
.inspection,
.installation,
.other {
    padding: 5px;
}

th {
    position: sticky;
}

.circle {
    border-radius: 50%;
    width: 30px;
    height: 30px;
    line-height: 30px;
    background-color: #DADADA;
    text-align: center;
    display: inline-block;
}
.label {
    line-height: 2;
}
p {
    font-size: 10px;
    line-height: 2em;
}

.inspection {

    background-color: rgba(250, 244, 60, 0.25);
    font-size: medium;
}

.intervention {

    background-color: rgba(244, 60, 250, 0.25);
    font-size: medium;
}

/*.installation {

  background-color: rgba(60, 117, 250, 0.25);
  font-size: medium;
}*/
.week {
    width: calc(1 / 7 * 100%);

}

.daycolumn {
    width: calc(1 / 7 * 100%);
}

.cell {
    border: 1px solid;
    height: 200px;
    vertical-align: baseline;
}

.tasklist {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-template-rows: repeat(5, 25px);
    grid-row-start: -1;
}

.tasklist>div {
    height: 25px;
}

.upper {
    text-transform: uppercase;
    margin-top: 5px;
    margin-bottom: 5px;
    padding: 5px;
    font-size: 12px;
}

.upper .circle {
    font-size: 15px;
}

.rightalign {
    text-align: end;
}

.workerheader-open>div {
    width: 200px;
}

.workerheader-closed>div {
    width: 23px;
}

/deep/ .collapsible-header {
    background-color: gray;
}

.collapsible i {
    right: 54%;
}

.hourtable th:first-child {
    padding-left: 16px;
}

/deep/ .dropdown-content {
    z-index: 102;
}

/deep/ .timepicker-modal {
    width: 75% !important;
}

/deep/ .timepicker-digital-display {
    background-color: #c22026 !important;
}

/deep/ .timepicker-canvas-bg {
    fill: #c22026 !important;
}

/deep/ .timepicker-canvas line {
    stroke: #c22026 !important;
}

/deep/ .timepicker-canvas-bearing {
    fill: #c22026 !important;
}

/deep/ .timepicker-tick:hover {
    background: #c22026 !important;
}

/deep/ .timepicker-close {
    color: #c22026 !important;
}

/deep/ ul#dropdownselectorplace {
    padding: 5px;
}

/deep/ ul#dropdownselectorplace label {
    color: black !important;
    font-size: 10px;
}

.task hr {
    margin: 0px !important;
    border-bottom-width: 0px;
    border-color: black;
}
/deep/ .taskfinished {
    text-decoration: line-through;
}
/deep/ label {
    color: black;
}
tr th {
    vertical-align: baseline;
}
.vue-daterange-picker {
    width: 100%;
    border-radius: 5px;
    height: 35px;
}
/deep/ select {
    display: block;
    background-color: white !important;
    border-radius: 4px !important;
    border-width: 1px !important;
    border-style: solid !important;
    border-color: rgb(140, 140, 140) !important;
    height: 37px;
}
</style>